import { Paper, styled } from '@mui/material';
import Color from 'color';

export const CardContainer = styled(Paper)(({ theme }) => {
  return {
    background:
      theme.palette.mode === 'dark'
        ? Color(theme.config.colors.darkGreyActive).darken(0.3).toString()
        : Color(theme.palette.background.active).lighten(0.065).toString(),
    padding: '2rem',
    borderRadius: 5,
    marginBottom: '2rem',
    position: 'relative',
  };
});
